// Highmaps options
const legendOptions = {
  align: "right",
  itemMarginBottom: 4,
  itemMarginTop: 1,
  itemStyle: {
    fontWeight: "normal",
  },
  labelFormat: "",
  layout: "horizontal",
  symbolHeight: 14,
  symbolWidth: 14,
  symbolRadius: 0,
  title: {
    style: {
      "textAlign": "right"
    }
  }
};

const mapTooltipOptions = {
  animation: true,
  backgroundColor: "transparent",
  borderWidth: 0,
  hideDelay: 100,
  shadow: false,
  shape: "square",
  style: { color: "black", padding: 0 },
  useHTML: true,
};

const defaultMapOptions = {
  chart: {
    backgroundColor: "#dddddd",
    height: 450,
    width: 800,
    margin: 50,
    style: {
      fontFamily: "'Open Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif"
    }
  },
  credits: {
    enabled: false,
  },
  exporting: {
    enabled: false
  },
  mapNavigation: {
    enabled: true,
    buttonOptions: {
      align: "left",
      verticalAlign: "middle"
    }
  },
  tooltip: mapTooltipOptions
};

export { legendOptions, defaultMapOptions, mapTooltipOptions };
